import React, { useState } from "react";
import { FaUserMd, FaClipboardList, FaMinus, FaPlus, FaFileMedical, FaServer,FaHospitalUser, FaBriefcaseMedical } from "react-icons/fa";
import { AiOutlineApi, AiOutlineSafetyCertificate, AiOutlineAppstore, AiOutlineCheckCircle } from "react-icons/ai";
import { MdSecurity, MdIntegrationInstructions } from "react-icons/md";
import { FaUsersCog, FaUserShield, FaHandshake, FaRegLightbulb, } from "react-icons/fa";
import Medpalm from "../../../assests/Secure.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        title: "Secure Online Consultations and Telehealth Services",
        description:
          "Access high-quality medical care from the comfort of your home through our secure telehealth platform. Schedule virtual consultations with certified doctors, receive instant diagnoses, and get e-prescriptions without visiting a hospital. Our HIPAA-compliant system ensures your medical data remains private and secure. Whether you need a general check-up or specialist advice, we make healthcare accessible anytime, anywhere.",
      },
      {
        title: "Affordable and Flexible Health Insurance Plans",
        description:
          "Choose from a range of cost-effective insurance plans tailored to cover routine check-ups, diagnostic tests, hospital stays, and specialized treatments. Our flexible options allow you to customize coverage based on your medical needs and budget. With transparent pricing, zero hidden charges, and hassle-free claim processing, we provide financial security and peace of mind for you and your loved ones.",
      },
      {
        title: "24/7 Emergency Medical Assistance",
        description:
          "Medical emergencies can occur anytime, and our dedicated emergency response team is available round-the-clock to provide immediate support. Whether it's ambulance services, urgent care coordination, or hospital admission assistance, we ensure quick and efficient medical intervention. Our wide network of hospitals and emergency units guarantees that you receive the right care at the right time, minimizing risks and improving survival rates.",
      },
      {
        title: "Comprehensive Chronic Disease Management",
        description:
          "Managing chronic conditions such as diabetes, hypertension, and heart disease requires continuous monitoring and personalized care. Our specialized programs offer regular health assessments, medication reminders, lifestyle coaching, and remote monitoring by healthcare professionals. We empower patients with digital health tools and real-time insights to help them stay in control of their health and prevent complications.",
      },
      {
        title: "Seamless Electronic Health Records (EHR) Integration",
        description:
          "Optimize healthcare delivery with our advanced Electronic Health Records (EHR) system. Our platform ensures seamless data exchange between hospitals, clinics, and pharmacies, enabling doctors to access accurate patient histories in real time. We adhere to industry standards such as HL7 and FHIR, ensuring interoperability, secure data storage, and compliance with healthcare regulations like HIPAA. Improve efficiency and patient outcomes with a fully integrated healthcare ecosystem.",
      },
      {
        title: "Dedicated Support for Medical Billing and Claims",
        description:
          "Navigating medical billing and insurance claims can be complex, but our dedicated support team simplifies the process. We assist in accurate documentation, claim submission, and faster reimbursements, ensuring a smooth experience for both patients and healthcare providers. Our automated billing solutions help reduce errors, prevent claim denials, and maintain transparency in medical expenses, making healthcare more accessible and stress-free.",
      },
    ];

const features = [
    { text: "Robust security measures for data protection.", icon: <AiOutlineApi className="text-[#2a627a] text-xl" /> },
    { text: "Affordable plans tailored to different needs.", icon: <AiOutlineSafetyCertificate className="text-[#2a627a] text-xl" /> },
    { text: "Integration with secure payment gateways.", icon: <AiOutlineAppstore className="text-[#2a627a] text-xl" /> },
    { text: "Advanced encryption for data privacy.", icon: <MdSecurity className="text-[#2a627a] text-xl" /> },
    { text: "Customizable security settings for users.", icon: <FaUsersCog className="text-[#2a627a] text-xl" /> },
    { text: "Streamlined authentication processes.", icon: <MdIntegrationInstructions className="text-[#2a627a] text-xl" /> },
    { text: "User-friendly interface with intuitive navigation.", icon: <FaClipboardList className="text-[#2a627a] text-lg" /> },
    { text: "Seamless integration with EHR systems.", icon: <FaUserMd className="text-[#2a627a] text-lg" /> },
    { text: "Automated claim processing for efficiency.", icon: <FaFileMedical className="text-[#2a627a] text-lg" /> },
    { text: "Cloud-based storage for real-time accessibility.", icon: <FaServer className="text-[#2a627a] text-lg" /> },
];


const benefits = [
    { text: "Reduced financial burden with cost-effective plans.", icon: <FaUserShield className="text-[#2a627a] text-xl" /> },
    { text: "Enhanced protection against cyber threats.", icon: <FaHandshake className="text-[#2a627a] text-xl" /> },
    { text: "Affordable access to essential services.", icon: <FaRegLightbulb className="text-[#2a627a] text-xl" /> },
    { text: "Improved trust and reliability in transactions.", icon: <MdSecurity className="text-[#2a627a] text-xl" /> },
    { text: "Ensures compliance with security regulations.", icon: <AiOutlineSafetyCertificate className="text-[#2a627a] text-xl" /> },
    { text: "Supports seamless user experience.", icon: <AiOutlineCheckCircle className="text-[#2a627a] text-xl" /> },
];

const cmsFeatures = [
    { icon: <FaUserShield className="text-[#2a627a] text-lg" />, text: "Advanced security protocols for patient data protection." },
    { icon: <FaRegLightbulb className="text-[#2a627a] text-lg" />, text: "Innovative cost-effective healthcare solutions." },
    { icon: <FaHospitalUser className="text-[#2a627a] text-lg" />, text: "Seamless patient access to medical records and services." },
    { icon: <FaHandshake className="text-[#2a627a] text-lg" />, text: "Trusted partnerships with secure healthcare providers." },
    { icon: <FaBriefcaseMedical className="text-[#2a627a] text-lg" />, text: "Flexible medical plans for individuals and families." },
    { icon: <MdSecurity className="text-[#2a627a] text-lg" />, text: "Ensures compliance with healthcare security regulations." },
];

const Secure = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full ">
                    <h1 className="font-semibold text-[30px] flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800"> Secure & Affordable Healthcare Solutions - <span className="text-gray-800">HikeHealth GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        Experience top-notch security with affordable pricing plans tailored to your needs.
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is Secure & Affordable?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                        Secure & Affordable healthcare ensures that patients and providers have protected, seamless access to essential medical services without financial burden. HikeHealth GS integrates advanced security protocols with cost-effective solutions, making healthcare accessible while maintaining privacy, compliance, and efficiency.
                        </p>
                    </div>


                </section>

                {/* Role in CMS Compliance */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in  Secure & Affordable
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default Secure;
